import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/stickyMenu.js";
import { useAuth } from "../../context/AuthContext";

const StickyMenu = () => {
  const { user, logout } = useAuth();
  const history = useHistory();

  useEffect(() => {
    const handleScroll = () => {
      const stickyMenu = document.querySelector(".sticky-menu");
      if (!stickyMenu) return;

      if (window.scrollY > 160) {
        stickyMenu.classList.add("sticky");
      } else {
        stickyMenu.classList.remove("sticky");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = () => {
    logout();
    history.push("/");
  };

  return (
    <Styles>
      {/* Sticky Menu */}
      <section
        className="sticky-menu"
        style={{
          left: user ? "250px" : "0",
          width: user ? "calc(100% - 250px)" : "100%",
        }}
      >
        <Container>
          <Row>
            <Col md="3">
              <div className="logo">
                <Link to={process.env.PUBLIC_URL + "/"}>
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/images/logo/logo2.png"
                    }
                    alt=""
                  />
                </Link>
              </div>
            </Col>
            <Col md="9">
              <div className="menu-box d-flex justify-content-end">
                <div className="menu-box d-flex align-items-center justify-content-between">
                  <ul className="nav menu-nav">
                    <li className="nav-item active">
                      <Link
                        className="nav-link"
                        to={process.env.PUBLIC_URL + "/"}
                      >
                        Home
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link"
                        to={process.env.PUBLIC_URL + "/about"}
                      >
                        About Us
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link"
                        to={process.env.PUBLIC_URL + "/courses"}
                      >
                        Courses
                      </Link>
                    </li>
                    {/* <li className="nav-item">
                      <Link
                        className="nav-link"
                        to={process.env.PUBLIC_URL + "/instructor"}
                      >
                        Instructor
                      </Link>
                    </li> */}
                    <li className="nav-item">
                      <Link
                        className="nav-link"
                        to={process.env.PUBLIC_URL + "/events"}
                      >
                        Events
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link"
                        to={process.env.PUBLIC_URL + "/blog-grid"}
                      >
                        Blog
                      </Link>
                    </li>
                  </ul>

                  {/* Right side buttons */}
                  <div className="right-buttons d-flex align-items-center gap-3">
                    <div className="user-auth d-flex align-items-center gap-2">
                      {user ? (
                        <button
                          type="button"
                          onClick={handleLogout}
                          className="logout-btn"
                        >
                          <i className="las la-sign-out-alt"></i>Logout
                        </button>
                      ) : (
                        <>
                          <Link
                            to={process.env.PUBLIC_URL + "/login"}
                            className="auth-btn"
                          >
                            Log In
                          </Link>
                          <Link
                            to={process.env.PUBLIC_URL + "/registration"}
                            className="auth-btn"
                          >
                            Register
                          </Link>
                        </>
                      )}
                    </div>

                    {!user && (
                      <div className="apply-btn">
                        <Link to={process.env.PUBLIC_URL + "/registration"}>
                          <i className="las la-clipboard-list"></i>Apply Now
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Styles>
  );
};

export default StickyMenu;
